import type { InvoicingPageStep } from '../types';
import { BillingDetails } from './BillingDetails';
import { SessionFeedback } from './SessionFeedback';
import { SessionInformation } from './SessionInformation';

export const steps: InvoicingPageStep[] = [
  { title: 'Session information', component: SessionInformation },
  { title: 'Billing details', component: BillingDetails },
  { title: 'Session feedback', component: SessionFeedback },
];
